module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages content"
  }, [_c('section', {
    staticClass: "pages-info-cont"
  }, [_c('z-input', {
    attrs: {
      "value": _vm.params.phone,
      "title": "用户名",
      "disabled": "disabled"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-20"
  }, [_c('z-input', {
    attrs: {
      "title": "商户名称",
      "maxlength": 20,
      "isMust": "true"
    },
    model: {
      value: (_vm.params.username),
      callback: function($$v) {
        _vm.$set(_vm.params, "username", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.username"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fx fx-y-center m-t-20"
  }, [_vm._m(0), _vm._v(" "), _c('z-upload', {
    attrs: {
      "file-url": _vm.params.logoUrl,
      "on-success": _vm.handleUploadSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pic-tips m-l-10"
  }, [_vm._v("建议尺寸：200*200")])], 1), _vm._v(" "), _c('div', {
    staticClass: "m-t-20 fx"
  }, [_c('p', {
    staticClass: "w120 m-r-5 fx-shrink"
  }), _vm._v(" "), _c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleValidation
    }
  }, [_vm._v("保存")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title fx w120 m-r-5"
  }, [_c('p', {
    staticClass: "ask-cont"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")])]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("商户头像")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-c077ce84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/users/Info.vue
// module id = 885
// module chunks = 0